import { Action } from 'redux'
import { AuthorizationActions } from '../../../reducers/userAccount/actionNames'

export const signOffFromSession = (fireToast: boolean = true): ISignOff => ({
  type: AuthorizationActions.SignOffTheAccount,
  fireToast,
})

export const flushState = (): IFlushState => ({
  type: AuthorizationActions.FlushState,
})

export type ISignOff = any
export type IFlushState = Action<AuthorizationActions.FlushState>
